import api from "../../../services/api";

export const getListUser = async () => {
  const response = await api.get('/api/cognito/admin/users');
  return response.data;
};
